import { Box } from '@mui/material'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { acGetCustomer } from '../../store/actions'
import { AppBar, Drawer, Loader, PanelBox, Snackbar } from '../default'
import { CompleteRegisterForm } from '../forms'

/**
 * Layout padrão com AppBar, Drawer e conteúdo com padding
 * @param {React.ReactNode} children - Conteúdo da página
 * @param {string} selectedKey - Chave da seção ativa no Drawer
 */
const Layout = ({ children, selectedKey }) => {

    const dispatch = useDispatch()

    const customer = useSelector(state => state.customer.customer)
    const isLoadingCustomer = useSelector(state => state.customer.isLoadingCustomer)

    const [snackbarData, setSnackbarData] = useState({ open: false, message: '' })

    useEffect(() => {
        if (!customer) {
            dispatch(acGetCustomer())
                .catch(error => console.error(error))
        }
    }, [dispatch, customer])

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setSnackbarData({ ...snackbarData, open: false })
    }

    return (
        <Box sx={{
            display: 'flex',
            height: '100vh',
            overflow: 'hidden'
        }}>

            <AppBar />

            {isLoadingCustomer && (
                <Loader color='secondary' />
            )}

            {(!isLoadingCustomer && customer) && (
                !customer.hasCompleteRegister ? (
                    <Box
                        component='main'
                        sx={{
                            flexGrow: 1,
                            padding: 2,
                            paddingTop: '64px',
                            transition: 'margin-left 0.3s ease',
                            height: '100vh',
                            overflowY: 'auto',
                            overflowX: 'hidden'
                        }}
                    >
                        <PanelBox title=''>
                            <CompleteRegisterForm setSnackbarData={setSnackbarData} />
                        </PanelBox>
                    </Box>
                ) : (
                    <>
                        <Drawer selectedKey={selectedKey} />

                        <Box
                            sx={{
                                flexGrow: 1,
                                padding: 2,
                                paddingTop: '64px',
                                transition: 'margin-left 0.3s ease',
                                height: '100vh',
                                overflowY: 'auto',
                                overflowX: 'hidden'
                            }}
                        >
                            {children}
                        </Box>
                    </>
                )
            )}

            <Snackbar
                open={snackbarData.open}
                onClose={handleSnackbarClose}
                message={snackbarData.message}
                severity={snackbarData.severity}
            />
        </Box>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    selectedKey: PropTypes.string.isRequired
}

export default Layout